import script from "./CalificarInstrumentoOpinionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalificarInstrumentoOpinionView.vue?vue&type=script&lang=ts&setup=true"

import "./CalificarInstrumentoOpinionView.vue?vue&type=style&index=0&id=a6bb8d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6bb8d86"]])

export default __exports__